/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react'
import Head from 'next/head'
import { SingletonRouter, withRouter } from 'next/router'
import getUrl from 'lib/url'
import { conformsTo, get } from 'lodash'
import { ContextProvider } from './reducer'
import { IConditionsProps, IInfoProps, ISortProps } from './interface'
import fetch from 'lib/decorated-fetch'
import BrandList from './brand-list'
import ConditionsList from './conditions-list'
import autoLibraryStyle from './less'
import { sort, conditions } from './conditions-config'
import { getCars, getParamsFromState } from './helper'
import { getSpider } from '../../server/common/utils'

interface IAutoProps {
  brands: IInfoProps[][]
  // 品牌字母
  letters: string[]
  // url中的query，用来初始化搜索结果
  query: any
  router: SingletonRouter
  options: any
  initProps: any
  asPath?: string
  spiderList?: any
}

function AutoLibrary(props: IAutoProps) {
  const { query, options, letters, brands, initProps, spiderList } = props
  const [init, setInit] = useState<any>(() => {
    return {
      ...initProps,
      ...options,
    }
  })

  const searchParams = query?.searchParams || query?.id

  // 顺序 ["0 价格", "1 级别", "2 国别", "3 变速箱", "4 结构", "5 排量", "6 能源", "7 座位数", "8 驱动方式", "9 安全配置", "10 舒适配置", "11 懂车分", "12 车系细分" 13 气缸数 14进气方式]
  // 默认展开的是 [0, 1,12,11,6,2] 其他只要存在需要展开
  const defaultShow = [0, 1, 12, 11, 6, 2]
  const foldParam = searchParams
    ?.split('-')
    ?.find((item: any, index: number) => {
      if (defaultShow.indexOf(index) < 0 && item !== 'x') {
        return true
      }
      return false
    })

  useEffect(() => {
    setInit({
      ...initProps,
      ...options,
    })
  }, [options, initProps])

  const fullYear = new Date().getFullYear()
  let title = ''
  let description = ''
  let keywords = ''

  try {
    // 选择品牌后
    if (initProps?.['brand']?.[0]?.['text']) {
      const brand = initProps?.['brand']?.[0]?.['text']
      title = `【${brand}品牌汽车】${brand}品牌汽车报价_${brand}品牌汽车报价_图片_懂车帝`
      // 目前数量拿不到，后面再加
      description = `懂车帝报价,${brand}品牌汽车报价频道,提供${fullYear}${brand}品牌汽车最新报价及图片信息,包含${brand}品牌汽车共1个在售车系,全部在售车型最新报价,图片,视频,4s店信息,最新${brand}品牌汽车信息尽在懂车帝官网。`
      keywords = `${brand}品牌汽车,${brand}品牌汽车报价,${brand}品牌汽车图片`
    }

    // 选择价格拼接
    if (options?.['price']?.[0] && options?.['price']?.[0]?.['text']) {
      const price = options?.['price']?.[0]?.['text']
      title += `${price}小型车报价_${price}小型车买什么车好_懂车帝`
      description += '汽车报价,汽车价格,汽车最新报价,懂车帝汽车报价'
      keywords +=
        '【汽车报价】懂车帝官网为您提供最新汽车报价信息，包括国产车、进口车各大品牌最新汽车价格，提供汽车经销商、图片、视频等参考信息。关注最新汽车报价，就上懂车帝官网。'
    }
  } catch (error) {
    console.error(error)
  }

  if (!title) {
    title = `车型大全_${fullYear}最新汽车图片及报价_热门车排行榜_懂车帝`
  }
  if (!description) {
    description =
      '懂车帝车型大全为您提供所有汽车品牌、厂商在产/停产全系车型,高清实拍、经销商报价，全网最低！帮您解决哪个车更值得购买的问题,自定义条件筛选,帮助您快速购车！'
  }
  if (!keywords) {
    keywords = `车型大全,${fullYear}最新汽车图片及报价,热门车排行榜`
  }

  return (
    <div>
      <Head>
        <title key="title">{title}</title>
        <meta key="keywords" name="keywords" content={keywords} />
        <meta key="description" name="description" content={description} />
        <link
          rel="canonical"
          href={`https://www.dongchedi.com/${props?.asPath?.split('?')?.[0]}`}
        />
      </Head>
      <div className="auto-library-wrap">
        <h2>条件选车</h2>
        <div className="wrap">
          <ContextProvider initProps={init}>
            <BrandList letters={letters} brands={brands} />
            <ConditionsList
              conditions={conditions}
              sort={sort}
              foldProps={foldParam}
              spiderList={spiderList}
            />
          </ContextProvider>
        </div>
        <style jsx>
          {`
            h2 {
              margin: 16px 0 16px 0;
              font-size: 14px;
              font-size: 14px;
              font-weight: normal;
              color: #1f2129;
            }
            .wrap {
              background: #fff;
            }
          `}
        </style>
        <style jsx global>
          {autoLibraryStyle}
        </style>
      </div>
    </div>
  )
}

// 重新处理数据
function reHandleData(data: any, query: any) {
  // 处理品牌
  let list: IInfoProps[] = []
  const brands: IInfoProps[][] = []
  const letters: string[] = []
  data?.brand &&
    data.brand?.forEach((item: IInfoProps) => {
      if (item.type === 1000) {
        letters.push(item.info.pinyin)
        brands.push(list)
        list = []
      }
      if (item.type === 1000 || item.type === 1001) {
        list.push(item)
      }
    })
  brands.push(list)
  brands.shift()

  // 热门当作 hot
  data?.hot_brand?.forEach((item: any) => {
    item.type = 1001 // 统一code
    if (item.info && item.info.pinyin) {
      item.info.pinyin = 'hot'
    }
  })
  data?.hot_brand && brands.push(data?.hot_brand)

  const options: any = {}

  const searchParams = query?.searchParams || query?.id
  if (searchParams) {
    const paramsList = searchParams?.split('-')

    conditions?.forEach((item: any, index: number) => {
      const param =
        paramsList?.[index] === 'x' ? 'x' : paramsList?.[index] || 'x'
      if (index !== 10 && index !== 9) {
        // 金额特殊处理
        if (index === 0) {
          const newItem: ISortProps | undefined = item.data.find(
            (option: any) =>
              option?.param?.toString() === param.toString().replace('!', '-')
          )
          if (newItem?.text === '不限') {
            return
          }
          try {
            const [low, high] = param?.split(',') || []
            if (high) {
              if (high === '!1') {
                options.price = [
                  newItem || {
                    param: param.toString().replace('!', '-'),
                    text: `${low}万以上`,
                    key: 'price',
                  },
                ]
              } else {
                options.price = [
                  newItem || {
                    param: param.toString().replace('!', '-'),
                    text: `${param?.split(',').join('-')}万`,
                    key: 'price',
                  },
                ]
              }
            }
          } catch (e) {
            console.error(e)
          }
        } else if (index === 11) {
          // 懂车分 特殊处理
          const newItem: ISortProps | undefined = item.data.find(
            (option: any) =>
              option?.param?.toString() === param?.toString()?.replace('!', '-')
          )
          if (newItem?.text === '不限') {
            return
          }
          try {
            options.dcar_score = [
              newItem || {
                param: param?.toString(),
                text: `${param?.split(',')?.join('-')}分`,
                key: 'dcar_score',
              },
            ]
          } catch (e) {
            console.error(e)
          }
        } else {
          const newItem: ISortProps | undefined = item.data.find(
            (option: any) =>
              option?.param?.toString() === param?.toString().replace('!', '-')
          )
          if (newItem?.key !== undefined && newItem?.key !== '') {
            options[newItem.key] = [newItem]
          }
        }
      } else {
        const list = paramsList?.[index]?.split('_')?.map((item: string) => {
          return parseInt(item, 10) || 0
        })
        list?.forEach((index: number) => {
          const newItem = item.data[index]
          if (newItem?.key !== '') {
            options[newItem.key] = [newItem]
          }
        })
      }
    })
  }

  return {
    options,
    conditions,
    sort,
    letters,
    brands,
  }
}

function handlePath(asPath: string) {
  const search = typeof asPath !== 'undefined' && asPath && asPath.split('?')[1]
  const queries = {} as any
  let initProps = {} as any
  if (search) {
    search?.split('&')?.forEach(function (c: string) {
      if (c === '') {
        return
      }
      const splitArr = c.split('=')
      const key = splitArr[0]
      queries[key] = splitArr.slice(1)
    })
    const keys = queries['key'] as string[]
    const param = queries['param'] as string[]
    const text = queries['text'] as string[]
    const more = queries['more'] as string[]
    if (keys && param && text) {
      initProps = keys.reduce((acc: any, curr, index) => {
        if (!curr) {
          return acc
        }
        if (!acc[curr]) {
          acc[curr] = []
        }
        acc[curr].push({
          param: Number(param?.[index]) || param?.[index],
          text: decodeURIComponent(text?.[index]),
          more: Number(more?.[index]) || more?.[index],
        })
        return acc
      }, {})
    }
  }
  return initProps
}

AutoLibrary.getInitialProps = async ({ query, asPath, req }: any) => {
  const json =
    (await fetch(getUrl('/motor/pc/car/brand/all_brand', 'motor.pc_car.api'), {
      req,
    }).catch((err) => {
      // no-op
    })) || {}

  const data = reHandleData(json.data, query) || {}
  const initProps = handlePath(asPath)

  /**
   * 如果是服务端请求，并且是蜘蛛，走服务端渲染
   */
  const ua = req?.headers?.['user-agent']
  let spiderList = null
  if (ua && getSpider(ua)) {
    const queryStr = getParamsFromState({
      ...initProps,
      ...data?.options,
    })
    spiderList = await getCars(queryStr)
  }

  const result = {
    _pageType: 'new',
    ...data,
    query,
    initProps,
    asPath,
    spiderList,
  }
  return result
}

export default withRouter<IAutoProps>(AutoLibrary)
